"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_redux_1 = require("react-redux");
var DetailGallery_1 = require("@/pages/detail/components/DetailGallery");
var DetailGalleryAction_1 = require("@/pages/detail/actions/DetailGalleryAction");
var mapDispatchToProps = function (dispatch) { return ({
    onSlidePrevClick: function (id) {
        return dispatch(DetailGalleryAction_1.default.onSlidePrevClick(id));
    },
    onSlideNextClick: function (id) {
        return dispatch(DetailGalleryAction_1.default.onSlideNextClick(id));
    },
    onThumbClick: function (id, index) {
        return dispatch(DetailGalleryAction_1.default.setGalleryIndex(id, index));
    },
    onSlideClick: function (id, i, slide) {
        return dispatch(DetailGalleryAction_1.default.onSlideClick(id, i, slide));
    },
    onSlideLoaded: function (id, i, slide, isPortrait) {
        return dispatch(DetailGalleryAction_1.default.onSlideLoaded(id, i, slide, isPortrait));
    },
    onMapViewClick: function () { return dispatch(DetailGalleryAction_1.default.onMapViewClick()); },
    onStreetViewClick: function () { return dispatch(DetailGalleryAction_1.default.onStreetViewClick()); },
    onViewFloorPlanClick: function () { return dispatch(DetailGalleryAction_1.default.onViewFloorPlanClick()); },
    onViewPhotoClick: function () { return dispatch(DetailGalleryAction_1.default.onViewPhotoClick()); },
}); };
var mapStateToProps = function (state, ownProps) { return (__assign({}, ownProps)); };
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(DetailGallery_1.detailGallery);
